import { motion } from "framer-motion";

const links = [
  { label: "Engagements", href: "#engagements", id: "nav-link-engagements" },
  { label: "Réalisations", href: "#realisations", id: "nav-link-realisations" },
  { label: "Services", href: "#services", id: "nav-link-services" },
  { label: "Secteur", href: "#zone", id: "nav-link-zone" },
  { label: "Rendez-vous", href: "#rendez-vous", id: "nav-link-booking" },
  { label: "Contact", href: "#contact", id: "nav-link-contact" },
];

export const Nav = () => (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1, delay: 0.4, ease: [0.76, 0, 0.24, 1] }}
    className="fixed top-0 left-0 right-0 z-40 border-b border-white/10 bg-obsidian/80 backdrop-blur-md"
    data-testid="main-nav"
  >
    <div className="flex items-center justify-between px-6 md:px-12 py-5">
      <a
        href="#top"
        data-testid="nav-logo"
        className="flex items-center gap-3 text-bone hover:text-gold transition-colors duration-500"
      >
        <svg width="36" height="20" viewBox="0 0 40 22" fill="none" aria-hidden="true">
          <path d="M0 6 Q 10 0, 20 6 T 40 6" stroke="#E39A3B" strokeWidth="2.4" strokeLinecap="round" />
          <path d="M0 12 Q 10 6, 20 12 T 40 12" stroke="#4A7FB5" strokeWidth="2.4" strokeLinecap="round" />
          <path d="M0 18 Q 10 12, 20 18 T 40 18" stroke="#C0392B" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
        <span className="font-serif text-xl tracking-tight">Brauer <span className="italic font-light">Élémentaire</span></span>
      </a>
      <nav className="hidden md:flex items-center gap-10">
        {links.map((l) => (
          <a
            key={l.id}
            href={l.href}
            data-testid={l.id}
            className="text-xs uppercase tracking-[0.25em] text-ash hover:text-bone transition-colors duration-500"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <a
        href="#contact"
        data-testid="nav-cta"
        className="md:hidden text-xs uppercase tracking-[0.25em] text-gold"
      >
        Contact
      </a>
    </div>
  </motion.header>
);
